import { useQuery } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

export const petRecordsQueryKey = (petId: string) => ['pets', petId, 'records'] as const

export function useGetPetRecords(petId: string) {
  const api = usePortalApi()
  return useQuery({
    queryKey: petRecordsQueryKey(petId),
    queryFn: async () => dataOrThrow(await api.get('/pets/:id/records', { params: { id: petId } })),
  })
}
